module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/d5tpBu/tc-custom/9780830825226.jpg?1697119613332",
      "alt": "This image is the cover for the book The Message of Revelation"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The Message of Revelation\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('strong', [_vm._v("What is the book of Revelation?")]), _vm._v(" Does it describe in veiled language events of its writer's own day, or is it largely a prophecy of events still to come? What should readers today do with strange scenes such as creatures covered with eyes, seven bowls of wrath, and a seven-headed dragon?")]), _vm._v(" "), _c('p', [_vm._v("Michael Wilcock lifts the curtain on Revelation as a drama in eight scenes, highlighting the role of the imagination in grasping this fascinating and enigmatic book. Guiding readers passage by passage, Wilcock explores Revelation's rich images and themes. We discover that deep reflection on this book stretches the mind and heart, calling us to encounter the love of God and the truths of the gospel in fresh and vibrant ways.")]), _vm._v(" "), _c('p', [_vm._v("This revised edition of a classic Bible Speaks Today volume features a new interior design, updated Scripture quotations, and light updates throughout.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Michael Wilcock\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }), _c('p', [_vm._v("Michael Wilcock was formerly director of pastoral studies at Trinity College, Bristol, and vicar of St. Nicholas' Church, Durham. He is also the author of "), _c('em', [_vm._v("Judges")]), _vm._v(", "), _c('em', [_vm._v("Chronicles")]), _vm._v(", "), _c('em', [_vm._v("Psalms")]), _vm._v(", and "), _c('em', [_vm._v("Luke")]), _vm._v(" in the Bible Speaks Today series.")]), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    IVP\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0